import { useLocation } from "react-router-dom";
import BackOffice from "@/components/account/BackOffice";
import OrdersHome from "@/components/backoffice/OrdersHome";
import ImagesGallery from "@/components/backoffice/ImagesGallery";
import ShopsScreen from "@/components/backoffice/admin/ShopsScreen";
import CatalogScreen from "@/components/backoffice/admin/CatalogScreen";
import FeesScreen from "@/components/backoffice/admin/FeesScreen";
import FlagsScreen from "@/components/backoffice/admin/FlagsScreen";

const SCREENS = {
    orders: () => <OrdersHome platform />,
    images: () => <ImagesGallery platform />,
    shops: () => <ShopsScreen />,
    catalog: () => <CatalogScreen />,
    fees: () => <FeesScreen />,
    flags: () => <FlagsScreen />,
};

/** 8.11 / 8.12 — the Simple platform admin: Orders | Images, then Shops · Catalog · Payouts & fees · Flags & mode, all on `/admin?tab=`. */
export default function SimpleAdmin() {
    const tab = new URLSearchParams(useLocation().search).get("tab") || "orders";
    const Screen = SCREENS[tab] || SCREENS.orders;
    return <BackOffice><div data-testid={`admin-simple-${SCREENS[tab] ? tab : "orders"}`}><Screen /></div></BackOffice>;
}
